// src/components/stop/LiveBusesList.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

function LiveBusesList({ buses }) {
  return (
    <Box>
      <Typography variant="h6" gutterBottom fontWeight="medium">
        🚌 Live Buses on Route
      </Typography>
      <Box component="ul" sx={{ pl: 2, m: 0, color: 'text.secondary' }}>
        {buses.length === 0 ? (
          <li>No live buses currently</li>
        ) : (
          buses.map(({ id, eta }) => (
            <li key={id}>
              Bus #{id} – ETA: {eta}
            </li>
          ))
        )}
      </Box>
    </Box>
  );
}

export default LiveBusesList;
